import { Box } from "@repo/components/src/ui/box";

import { HStack } from "@repo/components/src/ui/hstack";
import React from "react";
import PostCard from "./postCard";
import { UserNicheProps } from "./types";

const SharedProfileNiches = React.memo((props: UserNicheProps) => {
  return (
    <HStack flexSpace="lg" className="-mt-10 pt-7">
      {props.userNicheSet.map((n) => {
        const userNiche = n;
        return (
          <Box className="w-1/2 md:w-1/3" key={userNiche.id}>
            <PostCard userNiche={n} />
          </Box>
        );
      })}
    </HStack>
  );
});

SharedProfileNiches.displayName = "SharedProfileNiches";

export default SharedProfileNiches;
